import React from 'react';
import {
  Box,
  Card,
  CircularProgress,
  Container,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';

const InfoCardSkeleton = () => (
  <Card elevation={0} sx={{ border: 1, borderColor: 'divider', p: 3 }}>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Skeleton variant="rounded" width={40} height={40} />
      <Box sx={{ flex: 1 }}>
        <Skeleton height={12} sx={{ mb: 1 }} />
        <Skeleton height={16} width="75%" />
      </Box>
    </Stack>
  </Card>
);

export const JobPostSkeleton = () => (
  <Container maxWidth="lg" sx={{ py: 8, width: '100%' }}>
    <Grid container spacing={4}>
      <Grid item xs={12} lg={8}>
        <Stack spacing={4}>
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} md={6} key={item}>
                <InfoCardSkeleton />
              </Grid>
            ))}
          </Grid>

          <Card elevation={0} sx={{ border: 1, borderColor: 'divider', p: 4 }}>
            <Skeleton height={24} width="33%" sx={{ mb: 3 }} />
            <Stack spacing={1.5}>
              <Skeleton height={16} />
              <Skeleton height={16} width="83%" />
              <Skeleton height={16} width="80%" />
              <Skeleton height={16} width="75%" />
            </Stack>
          </Card>
        </Stack>
      </Grid>

      <Grid item xs={12} lg={4}>
        <Stack spacing={3}>
          <Card elevation={0} sx={{ border: 1, borderColor: 'divider', p: 3 }}>
            <Box sx={{ bgcolor: 'grey.100', borderRadius: 2, p: 3, textAlign: 'center', mb: 3 }}>
              <Skeleton height={20} width="66%" sx={{ mx: 'auto', mb: 1 }} />
              <Skeleton height={12} width="75%" sx={{ mx: 'auto', mb: 2 }} />
              <Skeleton height={40} />
            </Box>

            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Skeleton height={16} width="75%" sx={{ mx: 'auto', mb: 1 }} />
              <Skeleton height={12} width="66%" sx={{ mx: 'auto' }} />
            </Box>

            <Grid container spacing={1.5}>
              <Grid item xs={6}>
                <Skeleton height={48} variant="rounded" />
              </Grid>
              <Grid item xs={6}>
                <Skeleton height={48} variant="rounded" />
              </Grid>
            </Grid>

            <Box sx={{ borderTop: 1, borderColor: 'divider', pt: 2, mt: 2 }}>
              <Grid container spacing={1.5}>
                {[1, 2, 3, 4].map((item) => (
                  <Grid item xs={6} key={item}>
                    <Skeleton height={48} variant="rounded" />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Card>
        </Stack>
      </Grid>
    </Grid>

    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ mt: 4 }}>
      <CircularProgress size={20} />
      <Typography variant="body2" color="text.secondary">Loading job details...</Typography>
    </Stack>
  </Container>
);
